import React from 'react'

import { CgMenuRight } from 'react-icons/cg';
import { CgArrowRightO } from 'react-icons/cg';
import { VscChromeClose, VscFeedback } from 'react-icons/vsc';
import { BiUser } from 'react-icons/bi';
import { BsArrowDown } from 'react-icons/bs';
import { HiOutlineMail } from 'react-icons/hi';
import { FiPhone } from 'react-icons/fi';
import { IoChatboxOutline } from 'react-icons/io5';
import { SiFacebook, SiYoutube, SiTwitter, SiInstagram, SiLinkedin } from 'react-icons/si';

const sz = 18;
const c = "gray"

// tab icons
export const IconMenu = ({ color = c, size = sz }) => <CgMenuRight color={color} size={size} />

export const IconFb = ({ color = c, size = sz }) => <SiFacebook color={color} size={size} />
export const IconYt = ({ color = c, size = sz }) => <SiYoutube color={color} size={size} />
export const IconInsta = ({ color = c, size = sz }) => <SiInstagram color={color} size={size} />
export const IconLinkedIn = ({ color = c, size = sz }) => <SiLinkedin color={color} size={size} />
export const IconTwitter = ({ color = c, size = sz }) => <SiTwitter color={color} size={size} />

export const IconLinkArrow = ({ color = c, size = sz }) => <CgArrowRightO color={color} size={size} />

export const IconClose = ({ color = c, size = sz }) => <VscChromeClose color={color} size={size} />

export const IconAvatar = ({ color = c, size = sz }) => <BiUser color={color} size={size} />

export const IconArrowDown = ({ color = c, size = sz }) => <BsArrowDown color={color} size={size} />


export const IconEmail = ({ color = c, size = sz }) => <HiOutlineMail color={color} size={size} />
export const IconPhone = ({ color = c, size = sz }) => <FiPhone color={color} size={size} />
export const IconChat = ({ color = c, size = sz }) => <IoChatboxOutline color={color} size={size} />
export const IconFeedback = ({ color = c, size = sz }) => <VscFeedback color={color} size={size} />
